import { RewindModalParams } from 'common/components/RewindModal';
import { ROUTE } from 'common/configuration/constants';
import { hit as hit_jan } from 'common/tracking/jan';

export const trackOpenRewindModal = () => {
  hit_jan('social_action_click', {
    social_action_type: 'rewind',
    social_action_update_type: 'open',
    site_route: ROUTE
  });
};

export const trackNextRewindModal = (params?: RewindModalParams) => {
  hit_jan('social_action_click', {
    social_action_type: 'rewind',
    social_action_update_type: `open_${params?.flashbackType}`,
    site_route: ROUTE
  });
};

export const trackCloseRewindModal = (params?: RewindModalParams) => {
  const screenNameForTracking =
    params?.trackingScreenName || params?.screenName || '';
  hit_jan('social_action_click', {
    social_action_type: `rewind_${params?.flashbackType}`,
    social_action_update_type: `close_${screenNameForTracking}`,
    site_route: ROUTE
  });
};

export const trackShareRewindModal = (params?: RewindModalParams) => {
  const screenNameForTracking =
    params?.trackingScreenName || params?.screenName || '';
  hit_jan('social_action_click', {
    social_action_type: `rewind_${params?.flashbackType}`,
    social_action_update_type: `clic_share_${screenNameForTracking}`,
    site_route: ROUTE
  });
};

export const trackCaptifClickRewindModal = (params?: RewindModalParams) => {
  hit_jan('social_action_click', {
    social_action_type: `rewind_${params?.flashbackType}`,
    social_action_update_type: `open_partner`,
    site_route: ROUTE
  });
};
